import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async remove ({ dispatch }) {
    try {
      const collections = await directus.getCollections()
      const managed = collections.data.filter(item => item.managed)

      for (let item of managed) {
        await directus.deleteCollection(item.collection)
      }

      dispatch('removeFiles')
      dispatch('removeUsers')

      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}
